(function(){
  function adaptBigSlide(){    
    var mh = Math.max(600,$(window).height());
    console.log("adaptBigSlide",mh);
    //$('.big-slide').css({"min-height": mh + 'px'}); 
    // 1800 x 750
    mh = ($(window).width() / 1920) * 1593;
    $('.big-slide').css({"min-height": mh + 'px'}); 
  }
  
  $(document).ready(function(){
  	adaptBigSlide();
  });
  
  $(window).resize(function(){
    adaptBigSlide();
  });
  
}())